export const SAVE_COORDINATES = 'SAVE_COORDINATES';
export const SAVE_CURRENT_WEATHER = 'SAVE_CURRENT_WEATHER';
export const SAVE_ERROR_DESC = 'SAVE_ERROR_DESC';
export const SAVE_CURRENT_POSITION_DATA = 'SAVE_CURRENT_POSITION_DATA';
export const SAVE_HOURLY_FORECAST = 'SAVE_HOURLY_FORECAST';
export const SAVE_PREFERRED_THEME = 'SAVE_PREFERRED_THEME';
